import styled from "styled-components";

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 18px 8px;
  gap: 16px;
`;

export const Title = styled.h2`
  margin: 0;
  color: rgba(0, 0, 0, 0.75);
  font-size: 26px;
  font-weight: 700;
`;

export const SectionSubtext = styled.p`
  margin: 8px 0 0;
  color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
`;

export const ContentArea = styled.div`
  padding: 10px 18px 80px;
  min-height: calc(100vh - 190px);
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 18px;
`;

export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 28px rgba(67, 38, 102, 0.08);
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 160px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 32px rgba(67, 38, 102, 0.12);
  }
`;

export const CardTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  padding-right: 34px;
  word-wrap: break-word;
`;

export const CardMeta = styled.p`
  margin: 0 0 10px 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.55);
  flex-grow: 1;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
`;

export const EditIcon = styled.i`
  position: absolute;
  top: 20px;
  right: 20px;
  color: #ff8a23;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    color: #d96d0c;
  }
`;

export const EmptyState = styled.div`
  min-height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 18px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  background: linear-gradient(180deg, #fff 0%, #fffaf4 100%);
`;

export const LoadingState = styled(EmptyState)`
  border-style: solid;
`;
